// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-alpine {
	--ag-cell-horizontal-padding: 8px;
}

.ag-cell {
	padding-left: 4px !important;
	padding-right: 4px !important;
}
.ag-column-first {
	padding-left: 15px !important;
}

.ag-column-last {
	padding-right: 15px !important;
}

.ag-popup {
	position: static !important;
}

.ag-overlay-loading-wrapper {
	background-color: transparent !important;
	pointer-events: none !important;
}

.ag-row-odd {
	background-color: var(--py-primary-0) !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/organisms/Table/Table.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;AAClC;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;AACA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,wCAAwC;CACxC,+BAA+B;AAChC;;AAEA;CACC,gDAAgD;AACjD","sourcesContent":[".ag-theme-alpine {\n\t--ag-cell-horizontal-padding: 8px;\n}\n\n.ag-cell {\n\tpadding-left: 4px !important;\n\tpadding-right: 4px !important;\n}\n.ag-column-first {\n\tpadding-left: 15px !important;\n}\n\n.ag-column-last {\n\tpadding-right: 15px !important;\n}\n\n.ag-popup {\n\tposition: static !important;\n}\n\n.ag-overlay-loading-wrapper {\n\tbackground-color: transparent !important;\n\tpointer-events: none !important;\n}\n\n.ag-row-odd {\n\tbackground-color: var(--py-primary-0) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
